import { Route, Routes } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import {
  CalendarRangePage,
  DetailTicketFavoritePage,
  DetailTicketPage,
  DifficultRoutePage,
  FavoritesPage,
  FilterSearchAirCompanyPage,
  FilterSearchAirportPage,
  FilterSearchPage,
  FilterSearchPricePage,
  FilterSearchTimerPage,
  FilterSearchTransfersPage,
  InsuranceServicePage,
  ListResultsSearchPageWidget,
  MInstalmentAvia,
  MPlusAvia,
  MyOrderPage,
  PopularDirectionPage,
  PurchaseFormPage,
  ScanDocumentPage,
  ScanDocumentTunduk,
  SearchDirectionPage,
  SearchFormPage,
  SearchPage,
} from './page-imports'

export const AviaPages = () => {
  return (
    <Routes>
      <Route
        path={RoutingPaths.avia.myTickets.detail.base()}
        element={<MyOrderPage />}
      />

      <Route
        path={RoutingPaths.avia.mplus.base()}
        element={<MPlusAvia />}
      />

      <Route
        path={RoutingPaths.avia.minstalment.base()}
        element={<MInstalmentAvia />}
      />

      <Route
        path={`${RoutingPaths.avia.purchase.base()}/*`}
        element={<PurchaseFormPage />}
      />

      <Route
        path={RoutingPaths.avia.popularDirection.base()}
        element={<PopularDirectionPage />}
      />

      <Route
        path={RoutingPaths.avia.searchDirection.base()}
        element={<SearchDirectionPage />}
      />

      <Route
        path={RoutingPaths.avia.difficultRoute.base()}
        element={<DifficultRoutePage />}
      />

      <Route
        path={RoutingPaths.avia.searchDirection.base()}
        element={<SearchDirectionPage />}
      />

      <Route
        path={RoutingPaths.avia.detailTicket.base()}
        element={<DetailTicketPage />}
      />

      <Route
        path={RoutingPaths.avia.search.base()}
        element={<SearchPage />}
      />

      <Route
        path={RoutingPaths.avia.searchWidget.base()}
        element={<ListResultsSearchPageWidget />}
      />

      <Route
        path={`${RoutingPaths.avia.filter.base()}/*`}
        element={
          <Routes>
            <Route
              path={RoutingPaths.avia.filter.page()}
              element={<FilterSearchPage />}
            />

            <Route
              path={RoutingPaths.avia.filter.airport.base()}
              element={<FilterSearchAirportPage />}
            />

            <Route
              path={RoutingPaths.avia.filter.aircompany.base()}
              element={<FilterSearchAirCompanyPage />}
            />

            <Route
              path={RoutingPaths.avia.filter.timer.base()}
              element={<FilterSearchTimerPage />}
            />

            <Route
              path={RoutingPaths.avia.filter.transfers.base()}
              element={<FilterSearchTransfersPage />}
            />

            <Route
              path={RoutingPaths.avia.filter.price.base()}
              element={<FilterSearchPricePage />}
            />
          </Routes>
        }
      />

      <Route
        path={RoutingPaths.avia.calendar.base()}
        element={<CalendarRangePage />}
      />

      <Route
        path={RoutingPaths.avia.insuranceService.base()}
        element={<InsuranceServicePage />}
      />

      <Route
        path={RoutingPaths.avia.searchDirection.base()}
        element={<DetailTicketPage />}
      />

      <Route
        path={RoutingPaths.avia.searchForm.base()}
        element={<SearchFormPage />}
      />

      <Route
        path={RoutingPaths.avia.scanPassword.base()}
        element={<ScanDocumentPage />}
      />

      <Route
        path={RoutingPaths.avia.scanTunduk.base()}
        element={<ScanDocumentTunduk />}
      />

      <Route
        path={RoutingPaths.avia.favorites.base()}
        element={
          <Routes>
            <Route
              path={RoutingPaths.avia.favorites.page()}
              element={<FavoritesPage />}
            />

            <Route
              path={RoutingPaths.avia.favorites.detail.base()}
              element={<DetailTicketFavoritePage />}
            />
          </Routes>
        }
      />
    </Routes>
  )
}
